<script setup>
// Store
// Modal
import store from '@/store'
import ModalLayout from '@/components/Modals/ModalBase'
// Base Components
import BaseButton from '@/components/Base/Button/BaseButton'

const toggleInviteAdminPreviewModal = () => {
  store.dispatch('ToggleInviteAdminPreview')
  store.dispatch('ToggleModalInviteAdmin')
}
</script>

<template>
  <modal-layout modal-class="bg-white modal-adminPreview" :is-close="true">
    <template #modal-title>
      <span class="flex flex-row">
        <base-button
          class-name="modal-adminPreview-close-btn"
          btn-type="text"
          :functions="toggleInviteAdminPreviewModal">
          <template #contents>
            <i class="fa-solid fa-angle-left text-blacks-300"></i>
          </template>
        </base-button>
        <h1 class=" w-full modal-adminPreview-title">Email Preview</h1>
      </span>
      <hr class="h-[1px] w-full bg-[#c9c9c9]" />
    </template>
    <template #modal-subContent>
      <span class="mt-4 flex flex-col">
        <div>
          <span class="font-medium">From: </span> ProjectBoard
        </div>
        <div>
          <span class="font-medium">Subject: </span> You're Invited To Join ProjectBoard
        </div>
      </span>
    </template>
    <template #modal-content>
      <div class="modal-adminPreview-content">
        <p class="justify-center items-center">
          You’ve been invited by <span class="font-bold">(First Name Last Name) </span>
          to join their organization on ProjectBoard.
        </p>
        <div class="modal-adminPreview-btn" >
          <base-button id="confirmationSent"
                       name="confirmationSent"
                       class-name="modal-adminPreview-btn-container"
                       text="Accept Invite"
                       btn-type="primary"/>
        </div>
        <div class="modal-adminPreview-footer">
          <img src="/images/logo/projectboard.png"
               alt="login logo"
               class="modal-adminPreview-footer-logo" />
        </div>
      </div>
    </template>
  </modal-layout>
</template>

<style lang="scss" scoped>
.modal {
  &-adminPreview {
    @apply md:h-auto overflow-y-scroll max-w-md md:p-7 p-4 rounded-b-none md:rounded-2xl;
    &-content {
      @apply text-p-md text-center rounded-lg border-2 pt-14 pl-10 pr-10 pb-6 text-p-sm mt-6;
    }
    &-title {
      @apply text-h4 font-medium text-blacks-500 text-center pb-4;
    }
    &-hr {
      @apply w-full h-0.5 bg-greys-300;
    }
    &-btn {
      @apply w-full h-[2.5rem];
      &-container {
        @apply p-3 mt-8;
      }
    }
    &-footer {
      @apply flex w-full justify-center items-center pt-10 mt-10;
      &-logo {
        @apply w-auto h-[1rem] mb-1 mt-6;
      }
    }
  }
}
</style>
